import AlphabetCharacterType from "@Pages/countryPage/types/AlphabetCharacter.type";

export default function generateEnglishAlphabet(): AlphabetCharacterType[] {
    const en: AlphabetCharacterType[] = [];
    for (let i = 65; i < 91; i += 1) {
        en.push({letter: String.fromCharCode(i), order: (i - 64) * 10})
    }

    return en
}